/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {ForwardedRef, forwardRef, useImperativeHandle, useState} from 'react';

import EmailStep from '../../../models/emailStepModel';

import DaysSelect from './daysSelect';

import {ActivateHandle} from '../../../util/interfaces';

interface Props {
    onSubmit: (days: number, onlyWorkDays: boolean) => void;
}

function DaysSelectController(props: Props, ref: ForwardedRef<ActivateHandle>) {
    const {onSubmit} = props;
    const [days, setDays] = useState(12);
    const [active, setActive] = useState(false);
    const [onlyWorkDays, setOnlyWorkDays] = useState(false);

    function onActivate(step: EmailStep) {
        setDays(step.days || 12);
        setOnlyWorkDays(step.onlyWorkDays);
        setActive(true);
    }

    function onClose() {
        setActive(false);
        setDays(12);
        setOnlyWorkDays(false);
    }

    function onChange(days: number) {
        setDays(days);
    }

    function onChangeOnlyWorkDays(enabled: boolean) {
        setOnlyWorkDays(enabled);
    }

    function _onSubmit() {
        if (days) onSubmit(days, onlyWorkDays);
        onClose();
    }

    useImperativeHandle(ref, () => ({activate: onActivate}));

    return (
        <DaysSelect
            onChange={onChange}
            onClose={onClose}
            onSubmit={_onSubmit}
            onChangeOnlyWorkDays={onChangeOnlyWorkDays}
            days={days}
            active={active}
            onlyWorkDays={onlyWorkDays}
        />
    );
}

export default forwardRef<ActivateHandle, Props>(DaysSelectController);
